// const adaptRoutePath = () => {
// 	"/crear-grilla"
// 	"/docentes/editar/:id"
// 	"/docentes/editar/:id/materias/:materiaId"
// 	return
// 	"/crear-grilla"
// 	"/docentes/editar/n"
// 	"/docentes/editar/n/materias/n"
// }

import { Combinatoria } from "screens/Combinatoria/Combinatoria";

export const PRIVATE_ROUTE = {
  VISOR_PDF: "/visor-pdf",
  API: "/api",
  INICIO: "/inicio",
  PERFIL_USUARIOS: "/usuarios/:id",
  NORMATIVAS: "/normativas",
  DISEÑOS_CURRICULARES: "/diseños-curriculares",
  PLANES: "/planes",
  PLANES_CREAR: "/planes/crear",
  PLANES_EDITAR: "/planes/editar",
  PCI: "/pci",
  PCI_CREAR: "/pci/crear",
  PCI_EDITAR: "/pci/editar",
  MODALIDAD: "/modalidad",
  NIVELES: "/niveles",
  TITULOS: "/titulos",
  OPCION_PEDAGOGICA: "/opcion-pedagogica",
  TIPO_ESPACIO: "/tipo-espacio",
  AREA: "/area",
  CAJAS_CURRICULARES: "/cajas-curriculares",
  CAJAS_CURRICULARES_CREAR: "/cajas-curriculares/crear",
  CAJAS_CURRICULARES_EDITAR: "/cajas-curriculares/editar",
  USUARIOS: "/usuario",
  USUARIOS_PENDIENTES: "/pendientes",
  ORIENTACIONES: "/orientaciones",
  CERTIFICACIONES: "/certificaciones",
  ESPACIOS_CURRICULARES: "/espacios-curriculares",
  ESPACIOS_CURRICULARES_CREAR: "/espacios-curriculares/crear",
  ESPACIOS_CURRICULARES_EDITAR: "/espacios-curriculares/editar",
  CICLO: "/ciclo",
  COMBINATORIA: "/combinatoria",
  COMBINATORIA_CREAR: "/combinatoria/crear",
  COMBINATORIA_EDITAR: "/combinatoria/editar",
  ESPECIALIDAD: "/especialidad",
  VALIDEZ_NACIONAL: "/validez-nacional",
  ORGANISMO: "/organismo",
};
